import React, { useState } from 'react';
import { ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200">
      <button
        className="w-full py-6 flex justify-between items-center text-left"
        onClick={onClick}
      >
        <h3 className="text-lg font-semibold text-[#113262] pr-8">{question}</h3>
        <ChevronDown
          className={`w-5 h-5 text-[#F49611] transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''
            }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6' : 'max-h-0'
          }`}
      >
        <p className="text-gray-600">{answer}</p>
      </div>
    </div>
  );
};

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "What are the minimum investment requirements for offshore products?",
      answer: "Investment minimums vary by product. GIFT City AIFs typically have minimum investments of USD 150,000, while Singapore funds may have different requirements. Our team can provide specific details based on your chosen investment vehicle."
    },
    {
      question: "How are international investments taxed?",
      answer: "Taxation depends on the investment vehicle chosen. GIFT City AIFs have specific tax advantages, while Singapore-based investments follow different tax treatments. We provide detailed tax implications during consultation."
    },
    {
      question: "What is the process for repatriation of funds?",
      answer: "Fund repatriation follows RBI guidelines and varies by investment vehicle. The process is streamlined through our regulated structures, with clear documentation and compliance procedures."
    },
    {
      question: "How do you manage currency risk in offshore investments?",
      answer: "Currency risk management strategies are implemented based on the investment vehicle and market conditions. This may include natural hedges, currency overlays, or other risk management tools."
    },
    {
      question: "What types of global markets can I access?",
      answer: "Through our offshore solutions, you can access US equity markets, emerging market equities, and global bond markets. The specific access depends on the chosen investment vehicle and strategy."
    }
  ];

  return (
    <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
      <div className="flex flex-col md:flex-row gap-16">
        <div className="md:w-1/3">
          <div className="sticky top-8">
            <div className="w-12 h-0.5 bg-[#F49611] mb-3"></div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
              Common Questions About Offshore Investing
            </h2>
            <p className="text-gray-600 mb-8">
              Get answers to frequently asked questions about our offshore investment solutions.
              For more detailed discussions, our investment experts are ready to help.
            </p>
            <a href="/meeting" className="flex items-center text-[#F49611] font-semibold hover:gap-2 transition-all">
              <span>Speak With An Expert</span>
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </div>
        </div>
        <div className="md:w-2/3">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQSection;